module.exports = __webpack_public_path__ + "img/top.a5520647.png";